import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { routes } from 'flow/types/routes';
import PbxVoicemail from 'flow/pages/pbx/PbxSharedVoicemail';
import PbxSharedVoicemailSound from 'flow/route-components/PbxSharedVoicemailSound';
import SharedVoicemailEditor from 'flow/route-components/SharedVoicemailEditor';
import SharedVoicemailSettings from 'flow/route-components/SharedVoicemailSettings';

const PbxVoicemailRoutes = () => (
    <Switch>
        <Route
            path={routes['pbx.voicemails.voicemailKey.settings.sound']}
            component={PbxSharedVoicemailSound}
        />
        <Route
            path={routes['pbx.voicemails.entityKey.settings.edit.setting']}
            component={SharedVoicemailEditor}
        />
        <Route
            path={routes['pbx.voicemails.entityKey.settings']}
            component={SharedVoicemailSettings}
        />
        <Route
            path={routes['pbx.voicemails.entityKey']}
            component={PbxVoicemail}
        />
    </Switch>
);

export default PbxVoicemailRoutes;
